import { __decorate } from "tslib";
import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
let Graph = class Graph extends Vue {
    mounted() {
        setTimeout(() => {
            this.setLoading();
            this.reflow();
        }, 200);
    }
    get colors() {
        if (this.series.length === 1) {
            return [`#43e97b`];
        }
        return [
            `rgb(158, 95, 85)`,
            `rgb(119, 221, 119)`,
            `rgb(244, 154, 194)`,
            `rgb(255, 105, 97)`,
            `rgb(255, 179, 71)`,
            `rgb(202,200,201)`,
            `rgb(174, 198, 207)`,
            `rgb(143,182,255)`,
            `rgb(177, 156, 217)`,
        ];
    }
    get options() {
        const o = {
            boost: {
                usePreallocated: true,
            },
            colors: this.colors,
            chart: {
                zooming: {
                    type: 'x',
                },
                animation: false,
                backgroundColor: 'transparent',
                height: 250,
            },
            exporting: {
                buttons: {
                    contextButton: {
                        menuItems: ['downloadPNG', 'downloadSVG'],
                    },
                },
            },
            series: this.series,
            tooltip: {
                animation: false,
                valueDecimals: 2,
            },
            legend: {
                enabled: this.legend,
            },
            xAxis: {
                type: 'datetime',
                events: {
                    afterSetExtremes: this.zoom,
                },
            },
            yAxis: {
                title: {
                    text: this.yAxisTitle,
                },
                startOnTick: true,
                endOnTick: false,
                min: null,
            },
            credits: {
                enabled: false,
            },
            plotOptions: {
                series: {
                    animation: false,
                },
            },
            title: {
                text: this.title,
                align: 'left',
            },
        };
        return o;
    }
    setLoading() {
        if (!this.chart)
            return;
        if (this.loading) {
            this.chart.chart.showLoading();
        }
        else {
            this.chart.chart.hideLoading();
        }
        this.reflow();
    }
    zoom(event) {
        if (event.trigger === 'zoom') {
            this.$emit('zoom', event);
        }
    }
    onZoom() {
        this.chart.chart.xAxis.every((axis) => {
            axis.setExtremes(this.zoomValues.min, this.zoomValues.max, true, false);
        });
    }
    reflow() {
        if (!this.chart)
            return;
        this.chart.chart.reflow();
    }
};
__decorate([
    Prop({ required: true, type: String })
], Graph.prototype, "title", void 0);
__decorate([
    Prop({ required: true, type: String })
], Graph.prototype, "yAxisTitle", void 0);
__decorate([
    Prop({ required: true, type: Array })
], Graph.prototype, "series", void 0);
__decorate([
    Prop({ required: true, type: Object })
], Graph.prototype, "zoomValues", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], Graph.prototype, "loading", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], Graph.prototype, "legend", void 0);
__decorate([
    Ref('chart')
], Graph.prototype, "chart", void 0);
__decorate([
    Watch('loading')
], Graph.prototype, "setLoading", null);
__decorate([
    Watch('zoomValues', { deep: true })
], Graph.prototype, "onZoom", null);
Graph = __decorate([
    Component
], Graph);
export default Graph;
